(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-window-window-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-window-window-core'.");
    }
    globalThis['androidx-window-window-core'] = factory(typeof globalThis['androidx-window-window-core'] === 'undefined' ? {} : globalThis['androidx-window-window-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var addAll = kotlin_kotlin.$_$.o7;
  var toSet = kotlin_kotlin.$_$.tc;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var listOf = kotlin_kotlin.$_$.ta;
  var plus = kotlin_kotlin.$_$.ib;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(WindowSizeClass, 'WindowSizeClass');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(WindowWidthSizeClass, 'WindowWidthSizeClass');
  //endregion
  function createBreakpointSet($this, widthBreakpoints, heightBreakpoints) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = widthBreakpoints.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(heightBreakpoints, 10));
      var _iterator__ex2g4s_0 = heightBreakpoints.t();
      while (_iterator__ex2g4s_0.u()) {
        var item = _iterator__ex2g4s_0.v();
        var tmp$ret$5 = new WindowSizeClass(element, item);
        destination_0.j1(tmp$ret$5);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    return toSet(destination);
  }
  function WindowSizeClass_init_$Init$(widthDp, heightDp, $this) {
    WindowSizeClass.call($this, numberToInt(widthDp), numberToInt(heightDp));
    return $this;
  }
  function WindowSizeClass_init_$Create$(widthDp, heightDp) {
    return WindowSizeClass_init_$Init$(widthDp, heightDp, objectCreate(protoOf(WindowSizeClass)));
  }
  function Companion() {
    Companion_instance = this;
    this.exl_1 = 600;
    this.fxl_1 = 840;
    this.gxl_1 = 1200;
    this.hxl_1 = 1600;
    this.ixl_1 = 480;
    this.jxl_1 = 900;
    this.kxl_1 = listOf([0, 600, 840]);
    this.lxl_1 = plus(this.kxl_1, listOf([1200, 1600]));
    this.mxl_1 = listOf([0, 480, 900]);
    this.nxl_1 = this.mxl_1;
    this.oxl_1 = createBreakpointSet(this, this.kxl_1, this.mxl_1);
    this.pxl_1 = createBreakpointSet(this, this.lxl_1, this.nxl_1);
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function WindowSizeClass(minWidthDp, minHeightDp) {
    Companion_getInstance();
    this.qxl_1 = minWidthDp;
    this.rxl_1 = minHeightDp;
    // Inline function 'kotlin.require' call
    if (!(this.qxl_1 >= 0)) {
      var message = 'Expected minWidthDp to be at least 0, minWidthDp: ' + this.qxl_1 + '.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.rxl_1 >= 0)) {
      var message_0 = 'Expected minHeightDp to be at least 0, minHeightDp: ' + this.rxl_1 + '.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(WindowSizeClass).sxl = function () {
    return Companion_getInstance_0().wxl(this.qxl_1);
  };
  protoOf(WindowSizeClass).xxl = function (widthDpBreakpoint) {
    return this.qxl_1 >= widthDpBreakpoint;
  };
  protoOf(WindowSizeClass).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof WindowSizeClass))
      THROW_CCE();
    if (!(this.qxl_1 === other.qxl_1))
      return false;
    if (!(this.rxl_1 === other.rxl_1))
      return false;
    return true;
  };
  protoOf(WindowSizeClass).hashCode = function () {
    var result = this.qxl_1;
    result = imul(31, result) + this.rxl_1 | 0;
    return result;
  };
  protoOf(WindowSizeClass).toString = function () {
    return 'WindowSizeClass(minWidthDp=' + this.qxl_1 + ', minHeightDp=' + this.rxl_1 + ')';
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.txl_1 = new WindowWidthSizeClass(0);
    this.uxl_1 = new WindowWidthSizeClass(1);
    this.vxl_1 = new WindowWidthSizeClass(2);
  }
  protoOf(Companion_0).wxl = function (dpWidth) {
    // Inline function 'kotlin.require' call
    if (!(dpWidth >= 0)) {
      var message = 'Width must be positive, received ' + dpWidth;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return dpWidth < 600 ? this.txl_1 : dpWidth < 840 ? this.uxl_1 : this.vxl_1;
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function WindowWidthSizeClass(rawValue) {
    Companion_getInstance_0();
    this.yxl_1 = rawValue;
  }
  protoOf(WindowWidthSizeClass).toString = function () {
    var name = this.equals(Companion_getInstance_0().txl_1) ? 'COMPACT' : this.equals(Companion_getInstance_0().uxl_1) ? 'MEDIUM' : this.equals(Companion_getInstance_0().vxl_1) ? 'EXPANDED' : 'UNKNOWN';
    return 'WindowWidthSizeClass: ' + name;
  };
  protoOf(WindowWidthSizeClass).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var that = other instanceof WindowWidthSizeClass ? other : THROW_CCE();
    return this.yxl_1 === that.yxl_1;
  };
  protoOf(WindowWidthSizeClass).hashCode = function () {
    return this.yxl_1;
  };
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance;
  _.$_$.b = Companion_getInstance_0;
  _.$_$.c = WindowSizeClass_init_$Create$;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-window-window-core.js.map
